(() => {
  const STOPWORDS = new Set([
    'a', 'ad', 'al', 'alla', 'allo', 'ai', 'agli', 'all', 'alla', 'alle', 'con', 'da', 'dal', 'dalla', 'dalle',
    'dei', 'del', 'della', 'delle', 'di', 'ed', 'e', 'gli', 'i', 'il', 'in', 'la', 'le', 'lo', 'o', 'per', 'piu',
    'su', 'tra', 'un', 'una', 'uno'
  ]);

  const TYPE_RULES = [
    { key: 'crema', terms: ['crema', 'cream', 'creme', 'moisturizer', 'moisturiser'] },
    { key: 'siero', terms: ['siero', 'serum', 'booster', 'concentrato'] },
    { key: 'detergente', terms: ['detergente', 'detersione', 'cleanser', 'gel detergente', 'latte detergente'] },
    { key: 'maschera', terms: ['maschera', 'mask'] },
    { key: 'olio', terms: ['olio', 'oil'] },
    { key: 'scrub', terms: ['scrub', 'esfoliante', 'peeling', 'gommage'] },
    { key: 'shampoo', terms: ['shampoo'] },
    { key: 'balsamo', terms: ['balsamo', 'conditioner'] },
    { key: 'cofanetto', terms: ['cofanetto', 'kit', 'set', 'rituale', 'routine'] }
  ];

  const CONCERN_RULES = [
    {
      key: 'idratazione',
      terms: ['idratante', 'idratazione', 'pelle secca', 'secca', 'disidratata', 'disidratazione', 'nutriente', 'barriera', 'comfort'],
      search: 'idratante',
      combinations: {
        crema: 'crema idratante',
        siero: 'siero idratante',
        detergente: 'detergente delicato',
        maschera: 'maschera idratante',
        olio: 'olio nutriente',
        shampoo: 'shampoo nutriente',
        balsamo: 'balsamo nutriente',
        cofanetto: 'rituale idratante'
      }
    },
    {
      key: 'seboregolazione',
      terms: ['pelle grassa', 'grassa', 'oleosa', 'oleoso', 'pelle mista', 'mista', 'lucidita', 'sebo', 'pori', 'pori dilatati'],
      search: 'purificante',
      combinations: {
        crema: 'crema purificante',
        siero: 'siero purificante',
        detergente: 'detergente purificante',
        maschera: 'maschera purificante',
        scrub: 'scrub purificante',
        cofanetto: 'rituale purificante'
      }
    },
    {
      key: 'imperfezioni',
      terms: ['imperfezioni', 'brufoli', 'brufoletti', 'acne', 'anti acne', 'antiacne', 'comedoni'],
      search: 'anti-imperfezioni',
      combinations: {
        crema: 'crema anti-imperfezioni',
        siero: 'siero anti-imperfezioni',
        detergente: 'detergente anti-imperfezioni',
        maschera: 'maschera anti-imperfezioni',
        cofanetto: 'rituale anti-imperfezioni'
      }
    },
    {
      key: 'sensibile',
      terms: ['pelle sensibile', 'sensibile', 'reattiva', 'rossori', 'rossore', 'arrossamenti', 'arrossamento', 'delicata', 'lenitiva', 'calmante'],
      search: 'lenitiva',
      combinations: {
        crema: 'crema lenitiva',
        siero: 'siero lenitivo',
        detergente: 'detergente delicato',
        maschera: 'maschera lenitiva',
        cofanetto: 'rituale lenitivo'
      }
    },
    {
      key: 'luminosita',
      terms: ['illuminante', 'luminosita', 'pelle spenta', 'colorito spento', 'radiance', 'glow', 'vitamina c', 'vit c'],
      search: 'illuminante',
      combinations: {
        crema: 'crema illuminante',
        siero: 'siero illuminante',
        detergente: 'detergente illuminante',
        maschera: 'maschera illuminante',
        cofanetto: 'rituale illuminante'
      }
    },
    {
      key: 'macchie',
      terms: ['macchie', 'discromie', 'macchie viso', 'macchie pelle', 'melasma', 'post acne'],
      search: 'uniformante',
      combinations: {
        crema: 'crema uniformante',
        siero: 'siero uniformante',
        maschera: 'maschera uniformante',
        cofanetto: 'rituale uniformante'
      }
    },
    {
      key: 'antiage',
      terms: ['antiage', 'anti age', 'antirughe', 'rughe', 'linee sottili', 'rassodante', 'lift', 'lifting', 'mature'],
      search: 'antirughe',
      combinations: {
        crema: 'crema antirughe',
        siero: 'siero antirughe',
        maschera: 'maschera rassodante',
        olio: 'olio elasticizzante',
        cofanetto: 'rituale antirughe'
      }
    },
    {
      key: 'esfoliazione',
      terms: ['esfoliante', 'esfoliazione', 'grana', 'grana irregolare', 'texture', 'pelle ispessita'],
      search: 'esfoliante',
      combinations: {
        scrub: 'scrub esfoliante',
        detergente: 'detergente esfoliante',
        maschera: 'maschera esfoliante',
        cofanetto: 'rituale esfoliante'
      }
    },
    {
      key: 'capelli-secchi',
      terms: ['capelli secchi', 'capelli sfibrati', 'capelli danneggiati', 'capelli spenti', 'crespi', 'crespo'],
      search: 'nutriente capelli',
      combinations: {
        shampoo: 'shampoo nutriente',
        balsamo: 'balsamo nutriente',
        olio: 'olio capelli',
        maschera: 'maschera capelli nutriente',
        cofanetto: 'rituale capelli nutriente'
      }
    },
    {
      key: 'capelli-grassi',
      terms: ['capelli grassi', 'cute grassa', 'sebo capelli'],
      search: 'purificante capelli',
      combinations: {
        shampoo: 'shampoo purificante',
        balsamo: 'balsamo leggero',
        cofanetto: 'rituale capelli purificante'
      }
    },
    {
      key: 'corpo',
      terms: ['corpo', 'body', 'smagliature', 'elasticita corpo'],
      search: 'corpo',
      combinations: {
        crema: 'crema corpo',
        olio: 'olio corpo',
        scrub: 'scrub corpo',
        cofanetto: 'rituale corpo'
      }
    }
  ];

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, ' ')
      .replace(/[^a-z0-9\s-]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tokenize(value) {
    return normalizeText(value)
      .split(' ')
      .map((token) => token.trim())
      .filter((token) => token && !STOPWORDS.has(token));
  }

  function uniquePush(list, value) {
    const normalizedValue = normalizeText(value);
    if (!normalizedValue) return;
    if (!list.some((entry) => normalizeText(entry) == normalizedValue)) {
      list.push(value.trim());
    }
  }

  function includesTerm(haystack, needle) {
    const normalizedNeedle = normalizeText(needle);
    if (!normalizedNeedle) return false;
    return (` ${haystack} `).includes(` ${normalizedNeedle} `) || haystack.includes(normalizedNeedle);
  }

  function matchRule(normalizedQuery, rules) {
    return rules.find((rule) => rule.terms.some((term) => includesTerm(normalizedQuery, term)));
  }

  function buildQueryPlan(rawQuery) {
    const raw = String(rawQuery || '').trim();
    const normalized = normalizeText(raw);
    const cleaned = tokenize(raw).join(' ');
    const candidates = [];

    if (!normalized) {
      return {
        raw,
        normalized,
        cleaned,
        submitQuery: '',
        predictiveCandidates: []
      };
    }

    uniquePush(candidates, raw);

    const typeRule = matchRule(normalized, TYPE_RULES);
    const concernRule = matchRule(normalized, CONCERN_RULES);

    let submitQuery = cleaned || raw;

    if (typeRule && concernRule) {
      submitQuery = concernRule.combinations?.[typeRule.key] || `${typeRule.key} ${concernRule.search}`;
      uniquePush(candidates, submitQuery);
      uniquePush(candidates, concernRule.search);
    } else if (concernRule) {
      submitQuery = concernRule.search;
      uniquePush(candidates, submitQuery);
    } else if (typeRule && cleaned && cleaned !== raw) {
      submitQuery = cleaned;
      uniquePush(candidates, submitQuery);
    }

    if (typeRule) uniquePush(candidates, typeRule.key);
    if (concernRule?.search) uniquePush(candidates, concernRule.search);
    if (cleaned && cleaned !== raw) uniquePush(candidates, cleaned);

    return {
      raw,
      normalized,
      cleaned,
      submitQuery: submitQuery || raw,
      predictiveCandidates: candidates.filter(Boolean)
    };
  }

  const api = {
    normalizeText,
    buildQueryPlan,
    getSubmitQuery(rawQuery) {
      const plan = buildQueryPlan(rawQuery);
      return plan.submitQuery || String(rawQuery || '').trim();
    },
    getPredictiveCandidates(rawQuery) {
      const plan = buildQueryPlan(rawQuery);
      return plan.predictiveCandidates.length ? plan.predictiveCandidates : [String(rawQuery || '').trim()].filter(Boolean);
    }
  };

  window.DivettaSearchDictionary = api;

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.hasAttribute('data-disable-search-intelligence')) return;

      const searchInput = form.querySelector('input[name="q"]');
      if (!(searchInput instanceof HTMLInputElement)) return;

      const action = form.getAttribute('action') || '';
      const isSearchForm =
        form.getAttribute('role') === 'search' ||
        action.includes('/search') ||
        form.querySelector('input[name="type"][value="product"]');

      if (!isSearchForm) return;

      const rawQuery = searchInput.value || '';
      const rewrittenQuery = api.getSubmitQuery(rawQuery);

      if (!normalizeText(rewrittenQuery) || normalizeText(rewrittenQuery) === normalizeText(rawQuery)) return;

      searchInput.value = rewrittenQuery;
      form.dataset.dvSearchRewritten = 'true';
    },
    true
  );
})();
